// Multi-file picker strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.multifilefield.remove': 'Remove file',
  'ds.multifilefield.click_to_upload': 'Click to upload',
  'ds.multifilefield.or_drag_drop': 'or drag & drop — several at once',
  'ds.multifilefield.add_more': 'Add more files',
  'ds.multifilefield.count_one': '1 file selected',
  'ds.multifilefield.count_other': '{count} files selected',
  'ds.multifilefield.clear_all': 'Clear all',
}

export const zhTW = {
  'ds.multifilefield.remove': '移除檔案',
  'ds.multifilefield.click_to_upload': '點擊上傳',
  'ds.multifilefield.or_drag_drop': '或拖放檔案 — 可一次多個',
  'ds.multifilefield.add_more': '新增更多檔案',
  'ds.multifilefield.count_one': '已選擇 1 個檔案',
  'ds.multifilefield.count_other': '已選擇 {count} 個檔案',
  'ds.multifilefield.clear_all': '全部清除',
}
